import React, { useRef } from 'react';
import classnames from 'classnames';
import PopoverContainer from '@wix/da-ds/pkg/popper/_partials/PopoverContainer';
import { setRefs } from '../../../utils/refHelpers';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '@wix/da-ds/src/components/popper/PopoverWrapper/PopoverWrapper.scss';
/** This is a newer tooltip look, utilised by networkbar and some FTUE tooltips */ const AlternatePopoverContent = /*#__PURE__*/ React.forwardRef(({ effectivePlacement, effectiveSecondaryPlacement = 'middle', contentStyle, arrowStyle, wrapperClassName, contentClassName, arrowRef, rootRef, children, onClickOutside }, ref)=>{
    const contentRef = useRef(null);
    return /*#__PURE__*/ React.createElement(PopoverContainer, {
        ref: (node)=>setRefs([
                ref,
                rootRef
            ], node),
        placement: effectivePlacement,
        style: contentStyle,
        wrapperClassName: classnames(s[`placement-${effectivePlacement}`], s[`placement-${effectiveSecondaryPlacement}`], wrapperClassName),
        innerRef: contentRef,
        contentClassName: classnames(s['content'], contentClassName),
        arrow: /*#__PURE__*/ React.createElement("div", {
            ref: arrowRef,
            className: classnames(s['arrow'], s[`arrow-${effectivePlacement}`], s[`arrow-${effectiveSecondaryPlacement}`]),
            style: arrowStyle
        }),
        onClickOutside: onClickOutside
    }, children);
});
AlternatePopoverContent.displayName = 'AlternatePopoverContent';
export default AlternatePopoverContent;

//# sourceMappingURL=AlternatePopoverContent.js.map